import graphql__d31cae254c81029db563 from "./__generated__/ValidateContributionMutation.graphql.js";
import graphql__93d04b09788a853ea202 from "./__generated__/ValidateContributionMutation_updatedListContribution.graphql.js";
import graphql__a58f12dc0e49b8cfe253 from "./__generated__/ValidateContributionMutation_updatedCityWalkContribution.graphql.js";import { commitMutation, graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

import serializeAnswers from "../helpers/serializeAnswers";
import { addContributionEdgeToEligibleConnections } from "../components/Utils/contributionsConnections";
import {
  CONTRIBUTIONS_CONNECTION_TYPE_CONTRIBUTIONS,
  CONTRIBUTIONS_CONNECTION_TYPE_MARKERS
} from "../reducers/contributionsConnections";

const mutation = graphql__d31cae254c81029db563;

function validateContribution(
  contribution,
  currentPageId,
  form,
  edit,
  onCompleted,
  contributionsConnections
) {
  const { id: contribuableId } = contribution.contribuable;

  const variables = {
    contributionId: contribution.id,
    contribuableId,
    currentPageId,
    commentsCount: 0,
    answers: serializeAnswers(form),
    edit
  };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error),
    updater: (...args) =>
      mutationUpdater(contributionsConnections, contribuableId, ...args)
  });
}

// The mutation updater function allows for handling when the contribution is finally
// published, and ensures that the contribution is prepended to any visible or cached
// contributions list relay connection.
function mutationUpdater(
  contributionsConnections,
  contribuableId,
  store,
  { validateContribution }
) {
  // The `validateContribution` variable contains the raw response object with the actual
  // JSON data returned by the server, which allows us to fetch the `theme` object in a
  // manipulable format, to provide it to the `addContributionEdgeToEligibleConnections`
  // function to match relevant cached connections.
  const { theme } = validateContribution.contribution;

  // The `newContributionEdge` and `newContributionMarkerEdge` objects are fetched
  // directly from the mutation store entry, which allows us to manipulate their edges
  // and nodes with Relay's ConnectionHandler, as it requires manipulating relay edges and
  // not raw JSON data
  const rootField = store.getRootField("validateContribution");
  const newContributionEdge = rootField.getLinkedRecord("newContributionEdge");
  const newContributionMarkerEdge = rootField.getLinkedRecord(
    "newContributionMarkerEdge"
  );

  // Invalidate the contribuable record so that the UI is updated with new data where
  // needed.
  const contribuableRecord = store.get(contribuableId);

  if (contribuableRecord) {
    contribuableRecord.invalidateRecord();
  }

  // If no new edge was created, don't do anything as the record is not meant to be
  // displayed, either because the participative module doesn't display its
  // contributions, either because it's not yet publishable, either because it was a
  // contribution edition form.
  if (!newContributionEdge && !newContributionMarkerEdge) return;

  const contributionsListConnections =
    contributionsConnections[CONTRIBUTIONS_CONNECTION_TYPE_CONTRIBUTIONS];
  const contributionsMarkersConnections =
    contributionsConnections[CONTRIBUTIONS_CONNECTION_TYPE_MARKERS];

  // If there's a new contribution edge and we have already cached contributions
  // connections, ensure that the contribution is prepended to the relevant connections.
  if (newContributionEdge && contributionsListConnections) {
    addContributionEdgeToEligibleConnections(
      store,
      newContributionEdge,
      contributionsListConnections,
      theme
    );
  }

  // If there's a new contribution marker edge and we have already cached map
  // contributions markers connections, ensure that the contribution is prepended to
  // the relevant connections.
  if (newContributionMarkerEdge && contributionsMarkersConnections) {
    addContributionEdgeToEligibleConnections(
      store,
      newContributionMarkerEdge,
      contributionsMarkersConnections,
      theme
    );
  }
}

export { validateContribution };

// This is a fragment used by the above mutation to fetch the data needed by list
// contributions to be inserted into the contributions list UI once the contribution is
// finalized.
graphql__93d04b09788a853ea202;

// This is a fragment that's used by the above mutation to fetch the data needed by the
// city walks to update its UI once a contribution is validated.
graphql__a58f12dc0e49b8cfe253;
